export default "/public/dist/fonts/banner-5.svg";